import React ,{Component} from 'react'
import Car from '../../assets/images/Motorcycle.svg'
class Motorcycle extends Component{
    render(){
        const {width} =this.props

        return(
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 101 51"  xml="preserve" heigth="45px" width={width} fill="#58595B">
                 <title>Motorcycle</title>
                    <path className="st0" d="M28.8,47.2c5.6,0.2,10.3-4.2,10.5-9.8c0-0.4,0-0.7,0-1l4.1-0.6c0,0,0.1-0.2,1.1,0.9c0.4,0.4,1,0.5,1.5,0.5
                        c0.9,0.4,3.1,1,5.5,1.1c1.9,0.1,4.1-0.2,6-1.4c3-1.7,4.8-4.9,5.4-9.6c1.3-1.4,2.7-2.4,4-3.2l1,3.4c-3.6,1.5-6.1,4.9-6.3,9
                        c-0.2,5.6,4.2,10.3,9.8,10.5c5.6,0.2,10.3-4.2,10.5-9.8c0.2-5.6-4.2-10.3-9.8-10.5c-0.8,0-1.5,0-2.2,0.2l-1.1-3.8
                        c4-1.9,7.2-1.7,7.2-1.7l1.2,0.7l4,0.5c-2.3-2.9-11.9-2.7-11.9-2.7l2.1-0.3c0,0,0-2.2-1.2-4.9c-1.2-2.7-2.5-4.4-2.5-4.4
                        c-0.1,0.1-0.2,0.3-0.3,0.5c0.1-1.9,0.2-3.7,0.4-5.6c0,0,0,0,0-0.1c0.1-0.2,0-0.4-0.2-0.5c-0.7-0.4-1.5-0.7-2.3-0.8
                        c-0.2,0-0.4,0.2-0.5,0.4c-0.3,1-0.4,2-0.3,3c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.3-0.4-0.3-0.6-0.2c-0.2,0-0.5,0-0.6,0.3
                        c-0.2,0.5-0.6,0.8-0.6,1.3c-0.1,0.8,0.9,1.4,1.5,1.8c0.1,0.1,0.2,0.1,0.3,0.1c0.3,1.2,0.3,2.5,0.2,3.8c-1.9,1.2-1.2,2.3-1.2,2.3
                        l-0.4,0.6c0,0-1.7-2.6-7.7,1c-6,3.6-10.5,1-14.3-0.5c-2.7-1.1-10.5-1.8-14.9-2.1c-1.8-0.1-1.2,0.2-0.4,0.6c5,2,7.1,6.3,7.1,6.3
                        l-4.5-3c-3.5-0.3-2.2,2.5-1.7,2.8c0.5,0.3,8.8,5.8,8.8,5.8c2-0.7,4.2,1.6,4.2,1.6l2,3.8l-2.9,0.7c-1.4-3.8-4.9-6.5-9.2-6.7
                        c-5.6-0.2-10.3,4.2-10.5,9.8C18.8,42.3,23.2,47,28.8,47.2z M72.2,29.8c3.9,0.1,6.9,3.4,6.8,7.3c-0.1,3.9-3.4,6.9-7.3,6.8
                        c-3.9-0.1-6.9-3.4-6.8-7.3c0.1-2.7,1.7-5,4-6.1l2,6.7c0.1,0.4,0.5,0.7,1,0.7c0.1,0,0.2,0,0.3,0c0.5-0.2,0.9-0.7,0.7-1.3l-2-6.7
                        C71.3,29.8,71.7,29.8,72.2,29.8z M65.7,8.9c0.3-0.2,0.6-0.5,0.9-0.7c-0.1,1.5-0.2,3.1-0.2,4.6c-0.3,0.1-0.5,0.2-0.8,0.3
                        c0.1-1.4,0-2.7-0.4-4.1C65.3,9,65.5,9,65.7,8.9z M54.1,24.7c4.9-1.3,6.4,1,6.9,2.1c-0.6,4-2,6.8-4.4,8.2c-3.1,1.8-7.1,0.9-9.1,0.3
                        C47.8,32.5,49,26.1,54.1,24.7z M29.4,30c2.8,0.1,5.2,1.9,6.2,4.3L28,36.2l0.2,1.7l8-1.1c0,0.2,0,0.3,0,0.5c-0.1,3.9-3.4,6.9-7.3,6.8
                        c-3.9-0.1-6.9-3.4-6.8-7.3C22.3,32.9,25.5,29.9,29.4,30z"/>
            </svg>
        )
    }
}
export default  Motorcycle;



// WEBPACK FOOTER //
// ./src/components/Svgs/Motorcycle.js